const map = {
	"./ai-agent.js": 4157,
	"./ai-integratsiya.js": 5004,
	"./biznes-avtomatlashtirish.js": 6766,
	"./computer-vision.js": 9835,
	"./crm-tizimlar.js": 8776,
	"./desktop-ilova.js": 7409,
	"./erp-tizimlar.js": 4883,
	"./google-ads.js": 2319,
	"./google-business.js": 3939,
	"./internet-dokonlar.js": 9857,
	"./it-autsorsing.js": 1126,
	"./korporativ-saytlar.js": 7177,
	"./landing-page.js": 2306,
	"./mobil-ilova.js": 3562,
	"./seo.js": 6530,
	"./startap-saytlar.js": 243,
	"./sun-iy-intellekt.js": 8397,
	"./telegram-bot.js": 7648,
	"./texnik-qollab-quvvatlash.js": 5706,
	"./ux-ui-dizayn.js": 5587,
	"./veb-ilovalar.js": 4781,
	"./vizitka-saytlar.js": 5854
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8490;